import React from 'react';
import StudentClassList from './StudentClassList';


const StudentClassPage = () => {
  return (
    <div className='bg-[#f4f9ff] py-16'>
        <div className='xl:max-w-page m-auto'>
            <StudentClassList/>
        </div>
    </div>
  );
};

export default StudentClassPage;
